import { useState } from 'react';
import GridLayout, { WidthProvider } from 'react-grid-layout';
import { Page } from '@/components/page';
import { Toggle } from '@/components/toggle';
import { GridPanel } from '@/components/grid-panel';
import { useTabId } from '@/hooks/use-tab-id';
import { useScreenId } from '@/hooks/use-screen-id';
import { CapabilitiesListWidget } from '@/features/capabilities/components/capabilities-list-widget';

const layout = [{ i: 'list', x: 0, y: 0, w: 40, h: 25 }];

const AutoWidthGridLayout = WidthProvider(GridLayout);

export function Capabilities() {
  const [isDraggable, setIsDraggable] = useState(false);
  const tabId = useTabId();
  const screenId = useScreenId();
  const idPrefix = `${tabId}/${screenId}`;

  if (!screenId || !tabId) {
    return null;
  }

  return (
    <Page
      title="Capabilities"
      toolbar={
        <Toggle
          enabled={isDraggable}
          label="Enable drag"
          onChange={setIsDraggable}
        />
      }
    >
      <AutoWidthGridLayout
        className="layout"
        layout={layout}
        cols={40}
        rowHeight={25}
        isDraggable={isDraggable}
      >
        <GridPanel key="list">
          <CapabilitiesListWidget id={`${idPrefix}/list`} />
        </GridPanel>
      </AutoWidthGridLayout>
    </Page>
  );
}
